import { useMemo } from "react";
import type { Project, ProjectPackageReport } from "@proof/core";
import { ProjectExport, type ProjectExportServices } from "@proof/authoring";
import { Modal } from "./components";
import { useWorkspaceTransport } from "./WorkspaceContext";

export function ProjectPackage({
  project,
  onClose,
}: {
  project: Project;
  onClose: () => void;
}) {
  const { request } = useWorkspaceTransport();
  const services = useMemo<ProjectExportServices>(
    () => ({
      report: async (project, selection, signal) => {
        const response = await request("/documents/package/report", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ project, ...selection }),
          signal,
        });
        const result = await response.json();
        if (!response.ok)
          throw new Error(result.error || "Package verification failed");
        return result as ProjectPackageReport;
      },
      exportPackage: async (project, selection, signal) => {
        const response = await request("/documents/package", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ project, ...selection }),
          signal,
        });
        if (!response.ok)
          throw new Error(
            (await response.json()).error || "Package download failed",
          );
        return response.blob();
      },
    }),
    [request],
  );
  return (
    <Modal title="Portable project package" onClose={onClose} wide>
      <ProjectExport project={project} services={services} />
    </Modal>
  );
}
